<template>
    <div>
        <section class="media-center">
            <div class="container">
                <div class="date-picker" >
                    <v-date-picker :locale="{id: dateLanguage}" :input-props='{placeholder: "التاريخ", readonly: true}' transition="none" ref="datePicker" :step="1" :from-date="new Date()" :popover="{ placement: 'bottom-end', visibility: 'click' }" mode="range" v-model='selectedDate' :columns="1">
                        <div class="filter-label">
                            <i class="icon-calendar"></i>
                            <span id="filterDate">{{Filter}}<i class="icon-arrow-down" v-bind:class="{ 'arrow-active': isCalendarOpen }"></i></span>
                        </div>
                    </v-date-picker>
                    <div class="date-details" v-show="isReset">
                        <i class="icon-reset" v-on:click="resetDate"></i>
                        <input :value="dateValue" readonly />
                    </div>
                </div> 
                <div class="filter-data" v-show="isAnnouncements">
                    <span class="filter">{{Filter}}</span>
                    <multiselect v-model="filteredValue" :custom-label="nameWithLang" track-by="CategoryId" :options="options" :show-labels="false" :searchable="false" :allow-empty="false"></multiselect>
                </div>
                <div class="row">
                    <div class="col-md-4" v-bind:key="index" v-for="(item, index) in genericListingData">
                        <div class="generic-card news-card" v-bind:class="{ 'announcement-card': isAnnouncements }">
                            <div class="generic-card-link">
                                <div class="card-img" v-if="!isAnnouncements">
                                    <a :href="item.Url">
                                        <img :src="item.Image" alt="card image" @error="replaceByDefaultImg" />
                                    </a>
                                </div>
                                <div class="card-content">
                                    <div class="inner-content">
                                        <span class="card-date published-date" v-show="isNews || isAnnouncements">{{item.PublishedDate}}</span>
                                        <div class="card-date card-events-date" v-show="isEvents">
                                            <span>{{item.DateFrom}}</span>
                                            <span class="date-separator"></span>
                                            <span>{{item.DateTo}}</span>
                                        </div>
                                        <a :href="item.Url">
                                            <h2 class="card-title" v-show="isAnnouncements">{{item.AnnouncementsTitle}}</h2>
                                            <h2 class="card-title" v-show="isNews || isEvents">{{item.Title}}</h2>
                                        </a>
                                        <p class="card-brief">{{item.Brief}}</p>
                                    </div>
                                    <div class="card-link">
                                        <a :href="item.Url" class="read-more"><span>{{readMore}}</span><i class="icon-next"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="generic-error-message" v-show="showNoDataMessage">
                    <p class="message-text"><span>{{Sorry}}</span>{{NoDataFound}}</p>
                </div>
                <div class="generic-loader" v-show="isAjaxLoading">
                    <img src="../../../../../src/assets/spinner.svg" alt="EDA Spinner" />
                </div>
            </div>
        </section>

    </div>
</template>

<script>

    import DatePicker from 'v-calendar/lib/components/date-picker.umd';
    import Multiselect from 'vue-multiselect'
    import "vue-multiselect/dist/vue-multiselect.min.css";
    import moment from 'moment';
    import axios from 'axios';
    import Vue from 'vue';

    Vue.component('v-date-picker', DatePicker)

    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";
    let contactApiUrl;
    let listingThis;

    export default {
        props: {
            parentContentId: {
                type: String
            },
            Filter: {
                type: String
            },
            ViewAll: {
                type: String
            },
            readMore: {
                type: String
            },
            Sorry: {
                type: String
            },
            NoDataFound: {
                type: String
            },
            lang: {
                type: String
            },
            API: {
                type: String
            },
            CategoriesList: {
                type: String
            },
            isEvents: {
                type: Boolean
            },
            isNews: {
                type: Boolean
            },
            isAnnouncements: {
                type: Boolean
            }
        },
        components: {
            Multiselect
        },
        data() {
            return {
                genericListingData: [],
                scrollCount: 1,
                TotalCount: 0,
                selectedDate: {
                    start: null,
                    end: null
                },
                dateFrom: "",
                dateTo: "",
                dateValue: "",
                dateLanguage: 'en',
                showNoDataMessage: false,
                isthierMoreData: true,
                isAjaxLoading: false,
                isReset: false,
                isCalendarOpen: false,
                filteredCategory: "",
                filteredValue: "",
                options: []
            }
        },
        methods: {
            nameWithLang({ CategoryTitle }) {
                return `${CategoryTitle}`
            },
            getData() {
                listingThis.isAjaxLoading = true;
                if (listingThis.isNews) {
                    contactApiUrl = `${apiUrl}/umbraco/surface/${listingThis.API}?culture=${listingThis.lang}&contentId=${listingThis.parentContentId}&pageNumber=${listingThis.scrollCount}&startDate=${listingThis.dateFrom}&endDate=${listingThis.dateTo}`
                } else if (listingThis.isEvents) {
                    contactApiUrl = `${apiUrl}/umbraco/surface/${listingThis.API}?culture=${listingThis.lang}&contentId=${listingThis.parentContentId}&pageNumber=${listingThis.scrollCount}&startDate=${listingThis.dateFrom}&endDate=${listingThis.dateTo}`
                } else if (listingThis.isAnnouncements) {
                    contactApiUrl = `${apiUrl}/umbraco/surface/${listingThis.API}?culture=${listingThis.lang}&pageNumber=${listingThis.scrollCount}&filteredCategory=${listingThis.filteredCategory}`
                }
                axios.get(contactApiUrl).then(function (response) {
                    if (response.data.TotalCount != 0) {
                        listingThis.showNoDataMessage = false;
                        if (listingThis.scrollCount == 1) {
                            if (listingThis.isNews) {
                                listingThis.genericListingData = response.data.NewsItems;
                            } else if (listingThis.isEvents) {
                                listingThis.genericListingData = response.data.EventsItems;
                            } else if (listingThis.isAnnouncements) {
                                listingThis.genericListingData = response.data.AnnouncementsItems;
                            }
                            listingThis.TotalCount = response.data.TotalCount;                         
                        } else {
                            if (listingThis.isNews) {
                                listingThis.genericListingData = listingThis.genericListingData.concat(response.data.NewsItems);
                            } else if (listingThis.isEvents) {
                                listingThis.genericListingData = listingThis.genericListingData.concat(response.data.EventsItems);
                            } else if (listingThis.isAnnouncements) {
                                listingThis.genericListingData = listingThis.genericListingData.concat(response.data.AnnouncementsItems);
                            }
                        }
                    } else {
                        listingThis.isthierMoreData = false;
                        if (listingThis.scrollCount == 1) {
                            listingThis.genericListingData = [];
                            listingThis.showNoDataMessage = true;
                        }
                    }
                    listingThis.isAjaxLoading = false;
                })
                .then(() => {
                    listingThis.replaceEmptySrc();
                })
            },
            getFilterOptions: function () {
                axios.get(`${apiUrl}/Umbraco/surface/${listingThis.CategoriesList}?culture=${listingThis.lang}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then(function (res) {
                    listingThis.options = [{ CategoryId: "", CategoryTitle: listingThis.ViewAll }]
                    res.data.forEach((item) => {
                        listingThis.options.push(item);
                    })
                })
            },
            changeUrlParams: function () {
                let queryParams = new URLSearchParams(window.location.search);
                if (listingThis.isEvents) {
                    queryParams.delete("start-date");
                    queryParams.set("start-date", listingThis.selectedDate.start);
                    queryParams.delete("end-date");
                    queryParams.set("end-date", listingThis.selectedDate.end);
                    history.replaceState(null, null, "?" + queryParams.toString());
                } else if (listingThis.isAnnouncements) {
                    queryParams.delete("category");
                    queryParams.set("category", listingThis.filteredValue.CategoryTitle);
                    queryParams.delete("id");
                    queryParams.set("id", listingThis.filteredValue.CategoryId);
                    history.replaceState(null, null, "?" + queryParams.toString());
                }
            },
            getUrlParams: function () {
                const queryString = window.location.search;
                if (listingThis.isEvents) {
                    if (queryString != "") {
                        const urlParams = new URLSearchParams(queryString);
                        const start_date = moment(urlParams.get('start-date')).format('YYYY, M, DD');
                        const end_date = moment(urlParams.get('end-date')).format('YYYY, M, DD');
                        if (start_date == "Invalid date") {
                            listingThis.selectedDate = {
                                start: "",
                                end: ""
                            }
                        } else {
                            listingThis.selectedDate = {
                                start: new Date(start_date),
                                end: new Date(end_date)
                            }
                        }
                    }
                } else if (listingThis.isAnnouncements) {
                    const urlParams = new URLSearchParams(queryString);
                    const categoryId = urlParams.get('id');
                    const categoryName = urlParams.get('category');
                    if (categoryId != null && categoryName != null) {
                        listingThis.filteredValue = {
                            CategoryId: categoryId,
                            CategoryTitle: categoryName
                        }
                    }
                }
            },
            resetDate: function () {
                listingThis.selectedDate = {
                    start: "",
                    end: ""
                }
            },
            toggleCalendar: function () {
                setTimeout(() => {
                    if (document.querySelector('.date-picker .vc-popover-content-wrapper').classList.contains("is-interactive")) {
                        listingThis.isCalendarOpen = true;
                    } else {
                        listingThis.isCalendarOpen = false;
                    }
                }, 100)
            },
            replaceByDefaultImg(e) {
                e.target.src = "../../../../../src/assets/default.png";
            },
            replaceEmptySrc() {
                let cardsImg = document.querySelectorAll('.card-img img');
                cardsImg.forEach((item) => {
                    if (item.getAttribute('src') == null) {
                        item.src = '../../../../../src/assets/default.png';
                    }
                })
            },
            reload() {
                window.onpopstate  = function () {
                    location.reload();
                };
            }
        },
        mounted() {
            listingThis = this;

            if (listingThis.isNews || listingThis.isAnnouncements) {
                listingThis.getData();
            }
            if (listingThis.isAnnouncements) {
                listingThis.getUrlParams();
                listingThis.getFilterOptions();
                if (listingThis.filteredValue == "") {
                    listingThis.filteredValue = { CategoryId: "", CategoryTitle: listingThis.ViewAll };
                }
            }

            if (listingThis.isEvents) {
                listingThis.getUrlParams();

                if (listingThis.selectedDate?.start == null) {
                    listingThis.getData();
                }

                if (listingThis.lang == "ar-EG") {
                    listingThis.dateLanguage = 'ar';
                } else {
                    listingThis.dateLanguage = 'en';
                }

                const domChangeObserver = new MutationObserver(mutation => {
                    if (mutation[0].attributeName === 'class') {
                        listingThis.toggleCalendar();
                    }
                });

                domChangeObserver.observe(document.querySelector('.date-picker .vc-popover-content-wrapper'), {
                    attributes: true
                });
            }

            let observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !listingThis.isAjaxLoading && listingThis.isthierMoreData) {
                        if (listingThis.TotalCount != listingThis.genericListingData.length) {
                            listingThis.scrollCount++;
                            listingThis.getData();
                        }
                    }
                });
            });

            //this is make cause footer content is loaded late so it's positions changed
            setTimeout(function () {
                const container = document.querySelector(".footer");
                observer.observe(container);
            }, 100);

            if ('scrollRestoration' in history) {
                // Back off, browser, I got this...
                history.scrollRestoration = 'manual';
            }

        },
        watch: {
            'selectedDate.start': function () {
                listingThis.changeUrlParams();
                listingThis.dateFrom = moment(listingThis.selectedDate.start).format('YYYY-MM-DD');
                listingThis.dateTo = moment(listingThis.selectedDate.end).format('YYYY-MM-DD');
                if (listingThis.selectedDate.start == "") {
                    listingThis.isReset = false;
                    listingThis.dateValue = "";
                } else {
                    listingThis.isReset = true;
                    if (listingThis.lang == "ar-EG") {
                        listingThis.dateValue = moment(listingThis.dateFrom).format('YYYY-MM-DD') + ' - ' + moment(listingThis.dateTo).format('YYYY-MM-DD');
                    } else {
                        listingThis.dateValue = moment(listingThis.dateFrom).format('DD-MM-YYYY') + ' - ' + moment(listingThis.dateTo).format('DD-MM-YYYY');
                    }
                }
                listingThis.getData();
            },
            'filteredValue.CategoryTitle': function () {
                listingThis.changeUrlParams();
                listingThis.scrollCount = 1;
                listingThis.isthierMoreData = true;
                listingThis.filteredCategory = listingThis.filteredValue.CategoryId;
                listingThis.getData();
            }
        }
    }
</script>
